import React from "react";
import {
  Button,
  Box,
  Card,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  FormHelperText,
  MenuItem,
  Grid,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import { Link } from "react-router-dom";
import InputControl from "../../../shared/components/InputControl";
import { useGenaralSettings } from "../hooks/useGenaralSettings";
import { Loader } from "../../../shared";

export const GeneralSettings = () => {
  const {
    state,
    handleDayChange,
    onSaveEmailSettings,
    handleWebOrderFeeChange,
    onSaveWebOrderFeeSettings,
    formValidator,
  } = useGenaralSettings();

  return (
    <>
      {state.isLoading ? (
        <Loader />
      ) : (
        <>
          {formValidator.current.purgeFields()}
          <Card sx={{ p: "32px 24px", mb: "24px", overflow: "inherit" }}>
            <Stack direction="row" gap="32px" alignItems="center">
              <Stack direction="row" gap="4px" alignItems="center">
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  minWidth="136px"
                  lineHeight="19px"
                >
                  PL & BS File Upload Deadline
                </Typography>
              </Stack>
              <Stack
                flex={1}
                flexDirection="row"
                gap="16px"
                alignItems="center"
              >
                <FormControl width="218px">
                  <InputLabel id="demo-multiple-name-label">Day</InputLabel>
                  <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    value={state.plBsDetails}
                    input={<OutlinedInput label="Day" />}
                    MenuProps={{
                      style: {
                        maxHeight: 250,
                      },
                    }}
                    sx={{ width: "218px" }}
                    onChange={handleDayChange}
                  >
                    {[...Array(31).keys()].map((day) => {
                      const value = day + 1;
                      return (
                        <MenuItem key={value} value={value.toString()}>
                          {value}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {formValidator.current.message(
                    "plBsDetails",
                    state.plBsDetails,
                    "required"
                  )}
                </FormControl>
                <FormHelperText>of Every Month</FormHelperText>
              </Stack>
              <Button
                size="small"
                variant="contained"
                color="primary"
                sx={{ height: "40px" }}
                onClick={onSaveEmailSettings}
                disabled={state.isSaveButtonBusy || !state.hasPlBsChanges}
              >
                {state.isSaveButtonBusy ? "Saving..." : "Save"}
              </Button>
            </Stack>
          </Card>

          <Card sx={{ p: "32px 24px", mb: "24px" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography
                  variant="subtitle1"
                  fontWeight={600}
                  sx={{ width: "150px" }}
                >
                  Web Order Fee
                </Typography>
                <Box
                  component={Link}
                  to="/settings/history"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "primary.main",
                    mb: 1,
                    cursor: "pointer",
                    gap: "4px",
                    textDecoration: "none",
                    fontSize: "14px",
                    lineHeight: "16px",
                  }}
                >
                  History
                  <img
                    style={{
                      height: "16px",
                      filter:
                        "brightness(0) saturate(100%) invert(22%) sepia(56%) saturate(4832%) hue-rotate(214deg) brightness(86%) contrast(92%)",
                    }}
                    alt="link"
                    src="/icons/ic_external_link.svg"
                  />
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    fontSize: "12px",
                    lineHeight: "14px",
                    mb: 2,
                  }}
                >
                  Current orders processed with:
                  {state.webOrderFeeSettings.fee_type === "percentage"
                    ? `${Number(state.webOrderFeeSettings.fee_value).toFixed(
                        2
                      )}%`
                    : `$${Number(state.webOrderFeeSettings.fee_value).toFixed(
                        2
                      )}`}
                </Typography>
              </Grid>
              <Grid item sm={8}>
                <Stack>
                  <InputControl
                    type="switch"
                    value={state.webOrderFeeSettings.fee_status}
                    onChange={(e) => {
                      handleWebOrderFeeChange("fee_status", e.target.checked);
                    }}
                  />
                  {state.webOrderFeeSettings.fee_status ? (
                    <>
                      <Stack direction="row" gap="40px">
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="fee_apply_date_type"
                          value={state.webOrderFeeSettings.fee_apply_date_type}
                          sx={{
                            flexDirection: "row-reverse",
                          }}
                        >
                          {["percentage", "fixed"].map((data, index) => (
                            <FormControlLabel
                              key={index}
                              value={data}
                              control={<Radio />}
                              label={
                                data.charAt(0).toUpperCase() + data.slice(1)
                              }
                              onChange={(e) =>
                                handleWebOrderFeeChange(
                                  "fee_apply_date_type",
                                  e.target.value
                                )
                              }
                            />
                          ))}
                        </RadioGroup>
                      </Stack>
                      <Stack
                        sx={{
                          flexDirection: "row",
                          gap: "16px",
                          marginTop: "16px",
                        }}
                      >
                        <InputControl
                          type="number"
                          name="web_order_fee"
                          label={
                            state.webOrderFeeSettings.fee_apply_date_type ===
                            "percentage"
                              ? "Fee Percentage (%)*"
                              : "Fee Fixed*"
                          }
                          value={state.webOrderFeeSettings.fee_apply_date_value}
                          onChange={(e) => {
                            let value = e.target.value;
                            // Allow only numbers with up to 2 decimal places
                            if (/^\d*\.?\d{0,2}$/.test(value)) {
                              if (
                                state.webOrderFeeSettings
                                  .fee_apply_date_type === "percentage" &&
                                Number(value) > 100
                              ) {
                                value = "100";
                              }
                              handleWebOrderFeeChange(
                                "fee_apply_date_value",
                                value
                              );
                            }
                          }}
                          onBlur={(e) => {
                            let value = Number(e.target.value);
                            if (
                              state.webOrderFeeSettings.fee_apply_date_type ===
                                "percentage" &&
                              value > 100
                            ) {
                              value = 100;
                            }
                            const formattedValue = value.toFixed(2);
                            handleWebOrderFeeChange(
                              "fee_apply_date_value",
                              formattedValue
                            );
                          }}
                          placeholder={
                            state.webOrderFeeSettings.fee_apply_date_type ===
                            "percentage"
                              ? "Enter Fee Percentage"
                              : "Enter Fee Fixed Amount"
                          }
                          helperText={
                            state.webOrderFeeSettings.fee_status &&
                            formValidator.current.message(
                              "fee_value",
                              state.webOrderFeeSettings.fee_apply_date_value,
                              state.webOrderFeeSettings.fee_apply_date_type ===
                                "percentage"
                                ? "required|numeric|min:0,num|max:100,num"
                                : "required|numeric|min:0,num"
                            )
                          }
                          error={
                            state.webOrderFeeSettings.fee_status &&
                            formValidator.current.message(
                              "fee_value",
                              state.webOrderFeeSettings.fee_apply_date_value,
                              state.webOrderFeeSettings.fee_apply_date_type ===
                                "percentage"
                                ? "required|numeric|min:0,num|max:100,num"
                                : "required|numeric|min:0,num"
                            )
                          }
                        />
                        <Box sx={{ width: "100%" }}>
                          <InputControl
                            type="datePicker"
                            name="fee_apply_date"
                            label="Apply From"
                            inputFormat="dd-MM-yyyy"
                            minDate={new Date(Date.now() + 24 * 60 * 60 * 1000)} // Tomorrow's date
                            value={state.webOrderFeeSettings.fee_apply_date}
                            onChange={(date) =>
                              handleWebOrderFeeChange("fee_apply_date", date)
                            }
                            error={
                              state.webOrderFeeSettings.fee_status &&
                              formValidator.current.message(
                                "fee_apply_date",
                                state.webOrderFeeSettings.fee_apply_date,
                                "required|future_date"
                              )
                            }
                            helperText={
                              state.webOrderFeeSettings.fee_status &&
                              formValidator.current.message(
                                "fee_apply_date",
                                state.webOrderFeeSettings.fee_apply_date,
                                "required|future_date"
                              )
                            }
                            sx={{
                              width: "100%",
                            }}
                          />
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                              mt: "8px",
                            }}
                          >
                            <img
                              style={{
                                height: "14px",
                                filter:
                                  "brightness(0) saturate(100%) invert(60%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(88%) contrast(88%)",
                              }}
                              alt="info"
                              src="/icons/ic_info.svg"
                            />
                            <Typography
                              variant="caption"
                              sx={{
                                color: "text.secondary",
                                fontSize: "12px",
                                lineHeight: "14px",
                              }}
                            >
                              Fee will be effective from this date.
                            </Typography>
                          </Box>
                        </Box>
                      </Stack>
                    </>
                  ) : (
                    ""
                  )}
                  <Stack
                    direction="row"
                    justifyContent="flex-end"
                    sx={{ mt: 2 }}
                  >
                    <Button
                      size="small"
                      variant="contained"
                      color="primary"
                      onClick={onSaveWebOrderFeeSettings}
                      disabled={
                        state.isWebOrderFeeBusy || !state.hasWebOrderFeeChanges
                      }
                    >
                      {state.isWebOrderFeeBusy ? "Saving..." : "Save"}
                    </Button>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Card>
        </>
      )}
    </>
  );
};
